import React from 'react';
import { Checkbox, Grid } from 'semantic-ui-react';

const EXTRA_SPACE = '\u00A0\u00A0\u00A0\u00A0'
const FormsInputsDoubleCheckbox = ({field, form: {touched, errors, setFieldValue}, ...props}) => {

    return (
        <Grid.Row width={16}>
            <Grid.Row>
                {props.label}
            </Grid.Row>
            <Grid.Row>
                {EXTRA_SPACE}
                <Checkbox
                    name={field.name+"YES"}
                    id={field.name+"YES"}
                    label='Yes'
                    checked={(field.value === undefined)? false : field.value === true}
                    onChange={(e, data) => {
                        setFieldValue(field.name, true);
                    }}
                    onBlur={field.onBlur}
                    disabled={(props.disabled) ? props.disabled : false}
                />
            </Grid.Row>
            <Grid.Row>
                {EXTRA_SPACE}
                <Checkbox
                    name={field.name+"NO"}
                    id={field.name+"NO"}
                    label='No'
                    checked={(field.value === undefined)? false : field.value === false}
                    onChange={(e, data)=> {
                        setFieldValue(field.name, false);
                    }}
                    onBlur={field.onBlur}
                    disabled={(props.disabled) ? props.disabled : false}
                />
            </Grid.Row>
        </Grid.Row>
    );
}

export default FormsInputsDoubleCheckbox;
